import React, { Component } from 'react';
import '../../../sass/components/_modal.scss';

export default class GetProductionJsonModal extends Component {
  state = {
    savedCode: ''
  }
  updateSavedCode(code){
    // console.log(code);
    this.setState({
      savedCode: code
    })
  }
  clickSubmitBtn(e){
    e.preventDefault();
    e.stopPropagation();

    const {
      getSaveStatusApi
    } = this.props;
    const {
      savedCode
    } = this.state;

    getSaveStatusApi(savedCode);
  }
  render() {
    const {
      updateShowGetProductionJsonModal,
      isShowGetProductionJsonModal,
    } = this.props;
    const { savedCode } = this.state;
    return (
      <div className={isShowGetProductionJsonModal ? "modal fade show d-flex" : "modal fade show"}
        id="getProductionJsonModal" tabIndex="-1" aria-labelledby="loginErrorModalLiveLabel" aria-modal="true" role="dialog"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // updateShowGetProductionJsonModal(false);
        }}>
        <div className="modal-dialog modal-md">
          <div className="modal-content load-design">
            <div className="modal-header">
              <h5 className="modal-title" id="loginErrorModalLabel">載入設計規劃</h5>
              <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close"
                onClick={(e) => {
                  this.updateSavedCode('');
                  updateShowGetProductionJsonModal(false)
                }}
              >
              </button>
            </div>
            <div className="modal-body">
              <p>請輸入您的專屬設計編號</p>
              <div className="input-group mb-3">
                <input type="text" className="form-control" id="openIconModalTest" value={savedCode}
                  onChange={(e) => {
                    this.updateSavedCode(e.target.value);
                  }}
                />
                <button className="btn mx-2" type="button"
                  onClick={(e) => {
                    this.clickSubmitBtn(e);
                    this.updateSavedCode('');
                    updateShowGetProductionJsonModal(false);
                  }}
                >開啟</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
